import * as React from 'react';
import { Countdown } from 'components/Countdown';
import { withInjectedRootStore, RootStore } from 'providers';
import { Trans } from 'react-i18next';
import { Box, Text } from '@wix/design-system';
import { Country, Experiments } from 'enums';
import s from './SaleBanner.scss';
import dayjs from 'dayjs';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import classNames from 'classnames';

interface LastDaySaleBannerContentProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const LastDaySaleBannerContentComp: React.FunctionComponent<
  LastDaySaleBannerContentProps
> = ({ rootStore, experiments }) => {
  const { theme } = usePageModeContext();
  const { country } = rootStore.appStore.appContext;
  const { saleEndDate, currentDateUtc, discountPercent } =
    rootStore.appStore.appContext.saleParams;

  let endDate = saleEndDate;
  if (country === Country.USA || country === Country.CA) {
    endDate = +dayjs(endDate).subtract(1, 'minute');
  }

  const lastDayTextKey = experiments[Experiments.EnableImmediateCouponsDeliverySpec] === 'true' ?
    'premium-purchase-plan.header.sale_banner.biggest_sale_of_the_year' :
    'sale.banner.last_day_countdown';

  return (
    <Box
      dataHook='last-day-sale-banner-content'
      align='center'
      verticalAlign='bottom'
    >
      <Text dataHook='last-day-sale-text' weight='bold' size='small'>
        <Trans
          i18nKey={lastDayTextKey}
          values={{ percent: discountPercent || '50' }}
        >
          <span className={classNames(s.saleDiscountColor, theme)}>
            Save {{ percent: discountPercent || '50' }}%
          </span>
          rest
        </Trans>
      </Text>
      {endDate && (
        <Box marginLeft='SP1' marginBottom='2px'>
          <Countdown
            currentDate={currentDateUtc}
            endDate={endDate}
            classNames={{
              wrapper: s.countdown,
              timePart: s.countdownTimePart,
              label: s.countdownTimePartLabel,
              separator: s.countdownSeparator,
              timePartWrapper: s.countdownTimePartWrapper,
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export const LastDaySaleBannerContent = withInjectedRootStore(
  withExperiments(LastDaySaleBannerContentComp),
);
